import moment from 'moment';

import applicationDocsMapper from '@/shared/mappers/customers/finance-applications/application-docs.mapper';
import { PurchasesModel } from '@/shared/models/purchases.model';
import { PurchaseUiModel } from '@/shared/ui-models/purchase.ui-model';

function mapToModel(purchase: PurchaseUiModel): PurchasesModel {
  return {
    ...(purchase.id && { id: purchase.id }),
    ...(purchase.customer?.id && { userId: purchase.customer.id }),
    ...(purchase.merchant?.id && { merchantId: purchase.merchant.id }),
    ...(purchase.product?.id && { productId: purchase.product.id }),
    ...(purchase.customerApplication?.id && {
      applicationId: purchase.customerApplication.id
    }),
    ...(purchase.productType && { productType: purchase.productType }),
    ...(purchase.paymentMethod && { paymentMethod: purchase.paymentMethod }),
    ...(purchase.financeOfficer?.id && { financeOfficerId: purchase.financeOfficer.id }),
    ...(purchase.status && { status: purchase.status }),
    ...(purchase.supplierType && { supplierType: purchase.supplierType }),
    ...(purchase.supplierName && { supplierName: purchase.supplierName }),
    ...(purchase.autoSourceAgent?.id && { autoSourceAgentId: purchase.autoSourceAgent.id }),
    ...(purchase.autoProfitMargin && { autoProfitMargin: +purchase.autoProfitMargin })
  };
}

function mapToUi(purchase: PurchasesModel): PurchaseUiModel {
  return {
    id: purchase.id,
    customer: { id: purchase.user?.id ?? '', label: purchase.user?.name ?? '' },
    productType: purchase.productType,
    financeOfficer: {
      id: purchase.financeOfficer?.id ?? '',
      label: purchase.financeOfficer?.name ?? ''
    },
    paymentMethod: purchase.paymentMethod,
    status: purchase.status,
    createdAt: purchase.createdAt,
    createdBy: { name: purchase.createdByUser?.name ?? '' },
    updatedAt: purchase.updatedAt,
    merchant: {
      id: purchase.merchant?.id ?? '',
      label: purchase.merchant?.companyName.en ?? '',
      imageUrl: purchase.merchant?.url ?? ''
    },
    merchantDetails: purchase.merchant,
    product: {
      id: purchase.product?.id ?? '',
      label: `${purchase.product?.carBrand?.name?.en} - ${purchase.product?.carModel.en} (${purchase.product?.carChassis})`
    },
    productDetails: purchase.product,
    hasApplication: purchase.applicationId ? 'true' : 'false',
    applicationId: purchase.applicationId,
    customerApplication: {
      id: purchase.applicationId ?? '',
      label: `${purchase.application?.shortId} - ${purchase.application?.customer?.personalData?.idNameArabic}`,
      subLabel: [
        `${purchase.application?.financialMerchant?.companyName} / ${purchase.application?.financialProduct?.productName.en} / ${purchase.application?.product?.carBrand.name.en} - ${purchase.application?.product?.carModel.en}`
      ]
    },
    application: {
      id: purchase.applicationId ?? '',
      shortId: purchase.application?.shortId,
      agent: purchase.application?.agent?.name ?? '',
      merchantAgent: purchase.application?.merchantAgent?.name ?? '',
      lastUpdatedByUser: purchase.application?.lastUpdatedByUser?.name ?? '',
      lastUpdatedAt: purchase.application?.lastUpdatedAt,
      financialMerchant: purchase.application?.financialMerchant?.companyName.en ?? '',
      financialProduct: purchase.application?.financialProduct?.productName.en ?? '',
      merchant: purchase.application?.merchant?.companyName.en ?? '',
      product: `${purchase.application?.product?.carBrand?.name?.en} - ${purchase.application?.product?.carModel.en}`,
      status: purchase.application?.status
    },
    applicationDocuments: purchase.application?.applicationAttachments
      ? applicationDocsMapper.mapToUI(purchase.application?.applicationAttachments)
      : {},
    supplierType: purchase.supplierType,
    supplierName: purchase.supplierName,
    autoProfitMargin: purchase.autoProfitMargin,
    autoSourceAgent: {
      id: purchase.autoSourceAgentId ?? '',
      label: purchase.autoSourceAgent?.name ?? ''
    }
  };
}

const purchasesMapper = { mapToModel, mapToUi };

export default purchasesMapper;
